import { AudienceFragment, MessagingCampaignDetailsFragment } from '@occc/graphql';
import { parseDate } from '@occc-app/lib/date';
import { getFormValues } from '@occc/ui-notifications';

import { scheduleFormInitialValues, targetFormInitialValues } from './initial-values.utils';

import { MessagingCampaignConfigureFormValues } from '../components/configure-form/configure-form.types';
import { MessagingCampaignTargetFormInitialValues } from '../components/target-form/target-form.types';
import { MessagingCampaignScheduleFormInitialValues } from '../components/schedule-form/schedule-form.types';

type ConvertMessagingCampaignToInitialValuesParams = {
  campaign?: MessagingCampaignDetailsFragment | null;
  audience?: AudienceFragment;
};

type ConvertMessagingCampaignToInitialValuesReturns = {
  configure: Partial<MessagingCampaignConfigureFormValues>;
  target: MessagingCampaignTargetFormInitialValues;
  schedule: MessagingCampaignScheduleFormInitialValues;
};

export const convertMessagingCampaignToInitialValues = ({
  campaign,
  audience,
}: ConvertMessagingCampaignToInitialValuesParams): ConvertMessagingCampaignToInitialValuesReturns => {
  const configure: Partial<MessagingCampaignConfigureFormValues> = {
    ...getFormValues(campaign?.channelsConfig),
    title: campaign?.title ?? '',
    description: campaign?.description ?? undefined,
  };

  const target: MessagingCampaignTargetFormInitialValues = audience
    ? {
        inAudience: {
          id: audience.uuid,
          audience: {
            uuid: audience.uuid,
            membershipCount: audience.membershipCount,
            name: audience.name,
            status: audience?.status,
            hasBeenBackFilled: audience?.hasBeenBackFilled,
            targetingAttributes: audience?.targetingAttributes,
          },
        },
      }
    : targetFormInitialValues;

  const publishAt = parseDate(campaign?.scheduleAt || null);

  const schedule: MessagingCampaignScheduleFormInitialValues = campaign?.scheduleAt
    ? {
        publishAtDate: publishAt,
        publishAtTime: publishAt,
      }
    : scheduleFormInitialValues;

  return { configure, target, schedule };
};
